import { CalendarEventOccurrenceTarget } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChoiceDialog } from 'shared/dialogs/choice';

export type EventApplyToOccurrencesDialogProps = {
  onSelect: (occurrenceTarget: CalendarEventOccurrenceTarget) => void;
  onClose: () => void;
};

// Binds the calendar-event copy onto the shared prompt; both the save path and the drag
// path ask the same question, so neither owns the wording.
export const EventApplyToOccurrencesDialog: React.FC<
  EventApplyToOccurrencesDialogProps
> = ({ onSelect, onClose }) => {
  const { t } = useTranslation();

  const onSingle = () => onSelect(CalendarEventOccurrenceTarget.Single);
  const onThisAndFuture = () =>
    onSelect(CalendarEventOccurrenceTarget.ThisAndFuture);

  return (
    <ChoiceDialog
      open
      abovePopups
      title={t('forms.event.occurrence-target.title')}
      message={t('forms.event.occurrence-target.description')}
      primaryLabel={t('forms.event.occurrence-target.single')}
      secondaryLabel={t('forms.event.occurrence-target.this-and-future')}
      onPrimary={onSingle}
      onSecondary={onThisAndFuture}
      onCancel={onClose}
    />
  );
};
